import Api from '../api';
import axios from "axios";
import URI from "urijs";
export default (accessToken, decodedAccessToken, axiosOptions) => {
  const pmdcAxios = Api.pmdc(accessToken, axiosOptions);
  const pmdcAxiosV1_1 = Api.pmdc(accessToken, axiosOptions, '/v1.1');
  return {
    // Expose axios instance so
    // we can make low-level calls
    axios: pmdcAxios,
    // User & Account
    associateToken: function (confirmationToken) {
      for (var _len = arguments.length, restParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        restParams[_key - 1] = arguments[_key];
      }
      return pmdcAxios.post(`/confirmation-tokens/${confirmationToken}/accounts/${decodedAccessToken.sub}`, ...restParams);
    },
    getConfirmationTokenByValue: function (confirmationToken) {
      for (var _len2 = arguments.length, restParams = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        restParams[_key2 - 1] = arguments[_key2];
      }
      return pmdcAxios.get(`/confirmation-tokens/${confirmationToken}`, ...restParams);
    },
    getUserByAccount: function () {
      for (var _len3 = arguments.length, restParams = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        restParams[_key3] = arguments[_key3];
      }
      return pmdcAxios.get(`/accounts/${decodedAccessToken.sub}/user`, ...restParams);
    },
    accountExistsByConfirmationToken: function (confirmationToken) {
      for (var _len4 = arguments.length, restParams = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        restParams[_key4 - 1] = arguments[_key4];
      }
      return pmdcAxios.head(`/confirmation-tokens/${confirmationToken}/account`, ...restParams);
    },
    getAccountLinks: function () {
      for (var _len5 = arguments.length, restParams = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        restParams[_key5] = arguments[_key5];
      }
      return pmdcAxios.get('/linked-accounts', ...restParams);
    },
    getHubspotToken: function () {
      for (var _len6 = arguments.length, restParams = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        restParams[_key6] = arguments[_key6];
      }
      return pmdcAxios.get(`/accounts/${decodedAccessToken.sub}/user/hubspot-token`, ...restParams);
    },
    createEmailPasswordAccount: function (password) {
      for (var _len7 = arguments.length, restParams = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        restParams[_key7 - 1] = arguments[_key7];
      }
      return pmdcAxios.post('/create-credentials-account', {
        password
      }, ...restParams);
    },
    linkAccount: function () {
      for (var _len8 = arguments.length, restParams = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        restParams[_key8] = arguments[_key8];
      }
      return pmdcAxios.post('/link-account', null, ...restParams);
    },
    updateConnectedAt: function (userId) {
      for (var _len9 = arguments.length, restParams = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
        restParams[_key9 - 1] = arguments[_key9];
      }
      return pmdcAxios.post(`/users/${userId}/connection`, null, ...restParams);
    },
    changePassword: function (userId, password) {
      for (var _len0 = arguments.length, restParams = new Array(_len0 > 2 ? _len0 - 2 : 0), _key0 = 2; _key0 < _len0; _key0++) {
        restParams[_key0 - 2] = arguments[_key0];
      }
      return pmdcAxios.put(`/users/${userId}/password`, {
        password
      }, ...restParams);
    },
    // Steps
    getStepsMeta: function (clientType) {
      for (var _len1 = arguments.length, restParams = new Array(_len1 > 1 ? _len1 - 1 : 0), _key1 = 1; _key1 < _len1; _key1++) {
        restParams[_key1 - 1] = arguments[_key1];
      }
      return pmdcAxiosV1_1.get(`/meta-steps?clientType=${clientType}`, ...restParams);
    },
    getStepsByProject: function (projectId) {
      for (var _len10 = arguments.length, restParams = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
        restParams[_key10 - 1] = arguments[_key10];
      }
      return pmdcAxiosV1_1.get(`/projects/${projectId}/steps`, ...restParams);
    },
    // Projects
    getProjectsByUser: function (userId) {
      for (var _len11 = arguments.length, restParams = new Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
        restParams[_key11 - 1] = arguments[_key11];
      }
      return pmdcAxios.get(`/users/${userId}/projects`, ...restParams);
    },
    getProjectsByUserSortedByLast: function (userId, paginationParams, axiosOptions) {
      const {
        dealstatus,
        workTypeCodes,
        dates
      } = paginationParams;

      // NOTE THIBAUT : JE GARDE POUR HISTORIQUE. CALL A ANCIENNE API
      for (var _len12 = arguments.length, restParams = new Array(_len12 > 3 ? _len12 - 3 : 0), _key12 = 3; _key12 < _len12; _key12++) {
        restParams[_key12 - 3] = arguments[_key12];
      }
      return pmdcAxios.get(`/users/${userId}/projects`, {
        // let urlToCall = window.processRuntime.env?.NEW_API_BASE_URL+`/projects/user/${userId}`;
        //
        // return axios.get(urlToCall, {
        params: {
          ...paginationParams,
          'order-by': '-updatedAt',
          dealstatus: dealstatus ? JSON.stringify(dealstatus) : null,
          workTypeCodes: workTypeCodes ? JSON.stringify(workTypeCodes) : null,
          dealStatusTitles: null,
          dates: dates ? JSON.stringify(dates) : null
        },
        ...axiosOptions
      }, ...restParams);
    },
    getProjectById: function (projectId) {
      for (var _len13 = arguments.length, restParams = new Array(_len13 > 1 ? _len13 - 1 : 0), _key13 = 1; _key13 < _len13; _key13++) {
        restParams[_key13 - 1] = arguments[_key13];
      }
      return pmdcAxios.get(`/projects/${projectId}`, ...restParams);
    },
    getWorkTypes: function () {
      for (var _len14 = arguments.length, restParams = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
        restParams[_key14] = arguments[_key14];
      }
      return pmdcAxios.get('/work-types', ...restParams);
    },
    getWorkTypesWithoutPrice: function () {
      for (var _len15 = arguments.length, restParams = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
        restParams[_key15] = arguments[_key15];
      }
      return pmdcAxios.get('/work-types-without-price', ...restParams);
    },
    getFacilitatorByProject: function (projectId) {
      for (var _len16 = arguments.length, restParams = new Array(_len16 > 1 ? _len16 - 1 : 0), _key16 = 1; _key16 < _len16; _key16++) {
        restParams[_key16 - 1] = arguments[_key16];
      }
      return pmdcAxios.get(`/projects/${projectId}/facilitator`, ...restParams);
    },
    getSellerByProject: function (projectId) {
      for (var _len17 = arguments.length, restParams = new Array(_len17 > 1 ? _len17 - 1 : 0), _key17 = 1; _key17 < _len17; _key17++) {
        restParams[_key17 - 1] = arguments[_key17];
      }
      return pmdcAxios.get(`/projects/${projectId}/seller`, ...restParams);
    },
    updateLastVisit: function (projectId) {
      for (var _len18 = arguments.length, restParams = new Array(_len18 > 1 ? _len18 - 1 : 0), _key18 = 1; _key18 < _len18; _key18++) {
        restParams[_key18 - 1] = arguments[_key18];
      }
      return pmdcAxios.post(`/projects/${projectId}/visit`, null, ...restParams);
    },
    // Notifications
    getNotifications: function (projectId) {
      for (var _len19 = arguments.length, restParams = new Array(_len19 > 1 ? _len19 - 1 : 0), _key19 = 1; _key19 < _len19; _key19++) {
        restParams[_key19 - 1] = arguments[_key19];
      }
      return pmdcAxiosV1_1.get(`/projects/${projectId}/notifications`, ...restParams);
    },
    getNotificationsByUser: function (userId, paginationParams) {
      for (var _len20 = arguments.length, restParams = new Array(_len20 > 2 ? _len20 - 2 : 0), _key20 = 2; _key20 < _len20; _key20++) {
        restParams[_key20 - 2] = arguments[_key20];
      }
      return pmdcAxiosV1_1.get(`/users/${userId}/notifications`, {
        params: {
          ...paginationParams,
          sort: {
            createdAt: -1
          }
        }
      }, ...restParams);
    },
    getNotificationsMeta: function () {
      for (var _len21 = arguments.length, restParams = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
        restParams[_key21] = arguments[_key21];
      }
      return pmdcAxiosV1_1.get('/meta-notifications', ...restParams);
    },
    readNotification: function (notificationId) {
      for (var _len22 = arguments.length, restParams = new Array(_len22 > 1 ? _len22 - 1 : 0), _key22 = 1; _key22 < _len22; _key22++) {
        restParams[_key22 - 1] = arguments[_key22];
      }
      return pmdcAxiosV1_1.put(`/notifications/${notificationId}`, {
        isRead: true
      }, ...restParams);
    },
    // Actions
    getActions: function (projectId) {
      for (var _len23 = arguments.length, restParams = new Array(_len23 > 1 ? _len23 - 1 : 0), _key23 = 1; _key23 < _len23; _key23++) {
        restParams[_key23 - 1] = arguments[_key23];
      }
      return pmdcAxiosV1_1.get(`/projects/${projectId}/actions`, ...restParams);
    },
    getActionsByUser: function (userId, paginationParams) {
      for (var _len24 = arguments.length, restParams = new Array(_len24 > 2 ? _len24 - 2 : 0), _key24 = 2; _key24 < _len24; _key24++) {
        restParams[_key24 - 2] = arguments[_key24];
      }
      return pmdcAxiosV1_1.get(`/users/${userId}/actions`, {
        params: {
          ...paginationParams,
          sort: {
            createdAt: -1
          }
        }
      }, ...restParams);
    },
    getActionsMeta: function () {
      for (var _len25 = arguments.length, restParams = new Array(_len25), _key25 = 0; _key25 < _len25; _key25++) {
        restParams[_key25] = arguments[_key25];
      }
      return pmdcAxiosV1_1.get('/meta-actions', ...restParams);
    },
    updateActionStatus: function (actionId, status) {
      for (var _len26 = arguments.length, restParams = new Array(_len26 > 2 ? _len26 - 2 : 0), _key26 = 2; _key26 < _len26; _key26++) {
        restParams[_key26 - 2] = arguments[_key26];
      }
      return pmdcAxiosV1_1.put(`/actions/${actionId}`, {
        status
      }, ...restParams);
    },
    updateActionLinkStatus: function (actionId, linkId, status) {
      for (var _len27 = arguments.length, restParams = new Array(_len27 > 3 ? _len27 - 3 : 0), _key27 = 3; _key27 < _len27; _key27++) {
        restParams[_key27 - 3] = arguments[_key27];
      }
      return pmdcAxiosV1_1.put(`/actions/${actionId}/update-link-status/${linkId}`, {
        status
      }, ...restParams);
    },
    // Files
    getFilesByProject: function (projectId) {
      for (var _len28 = arguments.length, restParams = new Array(_len28 > 1 ? _len28 - 1 : 0), _key28 = 1; _key28 < _len28; _key28++) {
        restParams[_key28 - 1] = arguments[_key28];
      }
      return pmdcAxios.get(`/projects/${projectId}/files`, ...restParams);
    },
    deleteFileById: function (fileId) {
      for (var _len29 = arguments.length, restParams = new Array(_len29 > 1 ? _len29 - 1 : 0), _key29 = 1; _key29 < _len29; _key29++) {
        restParams[_key29 - 1] = arguments[_key29];
      }
      return pmdcAxios.delete(`/files/${fileId}`, ...restParams);
    },
    uploadFileByProject: function (projectId, body) {
      for (var _len30 = arguments.length, restParams = new Array(_len30 > 2 ? _len30 - 2 : 0), _key30 = 2; _key30 < _len30; _key30++) {
        restParams[_key30 - 2] = arguments[_key30];
      }
      return pmdcAxios.post(`/projects/${projectId}/files`, body, ...restParams);
    },
    getTemplateFolderContents: function () {
      for (var _len31 = arguments.length, restParams = new Array(_len31), _key31 = 0; _key31 < _len31; _key31++) {
        restParams[_key31] = arguments[_key31];
      }
      return pmdcAxios.get('/folders/template', ...restParams);
    },
    getRecommendations: function (projectId) {
      for (var _len32 = arguments.length, restParams = new Array(_len32 > 1 ? _len32 - 1 : 0), _key32 = 1; _key32 < _len32; _key32++) {
        restParams[_key32 - 1] = arguments[_key32];
      }
      return pmdcAxios.get(`/projects/${projectId}/recommendations`, ...restParams);
    },
    updateProjectName: function (dealId, newProjectname) {
      for (var _len33 = arguments.length, restParams = new Array(_len33 > 2 ? _len33 - 2 : 0), _key33 = 2; _key33 < _len33; _key33++) {
        restParams[_key33 - 2] = arguments[_key33];
      }
      return pmdcAxios.put(`/hubspot/deals/${dealId}/update-name`, {
        projectname: newProjectname
      }, ...restParams);
    },
    createProject: function (userId, payload) {
      for (var _len34 = arguments.length, restParams = new Array(_len34 > 2 ? _len34 - 2 : 0), _key34 = 2; _key34 < _len34; _key34++) {
        restParams[_key34 - 2] = arguments[_key34];
      }
      return pmdcAxios.post(`/users/${userId}/projects`, payload, ...restParams);
    },
    updateDealStage: function (dealId, dealStageId) {
      for (var _len35 = arguments.length, restParams = new Array(_len35 > 2 ? _len35 - 2 : 0), _key35 = 2; _key35 < _len35; _key35++) {
        restParams[_key35 - 2] = arguments[_key35];
      }
      return pmdcAxios.put(`/hubspot/deals/${dealId}/update-dealstage`, {
        dealStageId
      }, ...restParams);
    }
  };
};